webpackJsonp([19],{

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vant_es_toast_style__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant_es_toast__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Common_ajax__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Constans__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Common_util__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Common_cookie__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Views_components_header__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Views_components_foot__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Views_components_mobilefoot__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_Views_components_menu__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_meta__ = __webpack_require__(27);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vant_es_toast__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_meta__["a" /* default */]);
var userUrl = __WEBPACK_IMPORTED_MODULE_4_Constans__["a" /* default */].AllUrl.url.dev;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    myHeader: __WEBPACK_IMPORTED_MODULE_7_Views_components_header__["a" /* default */],
    myFooter: __WEBPACK_IMPORTED_MODULE_8_Views_components_foot__["a" /* default */],
    mobilefoot: __WEBPACK_IMPORTED_MODULE_9_Views_components_mobilefoot__["a" /* default */],
    myMenu: __WEBPACK_IMPORTED_MODULE_10_Views_components_menu__["a" /* default */]
  },
  data: function data() {
    return {
      noattention: false,
      attentionList: [],
      canonicalUrl: '',
      title: '',
      desc: '',
      isMobile: true
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: this.title,
      meta: [{
        vmid: "description",
        name: "description",
        content: this.desc
      }],
      link: [{
        ref: "canonical",
        href: this.canonicalUrl
      }]
    };
  },
  created: function created() {
    var that = this;
    this.fetchData();
    var _arg = __WEBPACK_IMPORTED_MODULE_5_Common_util__["a" /* default */].getQueryStringArgs();
    var language = __WEBPACK_IMPORTED_MODULE_6_Common_cookie__["a" /* default */].getCookie('language');
    if (__WEBPACK_IMPORTED_MODULE_5_Common_util__["a" /* default */].getLang() == 'cn' || _arg.lang == 'zh-Hans-TW' || language == '简体中文') {
      that.canonicalUrl = 'https://www.lespark.cn/topic.html?lang=zh-Hant-TW';
      that.title = '话题互动 - LesPark';
      that.desc = 'LesPark集合了关于les交友、当下热点等女性用户感兴趣的话题，还有拉拉感兴趣的各种热门话题推荐，在此您可以与全球女性沟通互动。';
    } else if (__WEBPACK_IMPORTED_MODULE_5_Common_util__["a" /* default */].getLang() == 'en' || _arg.lang == 'en' || language == 'English') {
      that.canonicalUrl = 'https://www.lespark.cn/topic.html?lang=en';
      that.title = 'Lesbian community - Topic interaction - LesPark';
      that.desc = 'LesPark is a collection of popular topics of interest to lesbians, where you can interact with women from all over the world.';
    } else {
      that.canonicalUrl = 'https://www.lespark.cn/topic.html';
      that.title = '拉拉社區 - 話題互動 - LesPark';
      that.desc = 'LesPark集合了關於les交友、當下熱點等女性用戶感興趣的話題，還有拉拉感興趣的各種熱門話題推薦，在此您可以與全球女性溝通互動。';
    }
  },
  mounted: function mounted() {
    var that = this;
    that.changeType();
    window.addEventListener('resize', __WEBPACK_IMPORTED_MODULE_5_Common_util__["a" /* default */].debounce(that.changeType, 1000));
  },

  methods: {
    goTopic: function goTopic(value) {
      window.location.href = '/topic/' + value;
    },
    changeType: function changeType() {
      var that = this;
      if (document.documentElement.clientWidth < 960) {
        that.isMobile = true;
      } else {
        that.isMobile = false;
      }
    },
    fetchData: function fetchData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3_Common_ajax__["a" /* default */].Get({
        url: userUrl + "/v2/get_hot_tags?_t=" + new Date().getTime(),
        headers: {
          bundle_id: "pc",
          'bundle-id': 'pc',
          lang: "zh-hans",
          token: "",
          user_id: ''
        }
      }).then(function (ref) {
        var data = ref.data;
        _this.attentionList = data.tags || [];
        if (_this.attentionList.length == 0) {
          _this.noattention = false;
        } else {
          _this.noattention = true;
        }
      }).catch(function (ref) {
        console.log(ref);
      });
    }
  }
});

/***/ }),

/***/ 701:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_vue__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bus__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_i18n__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Views_css_reset_css__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Views_css_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_Views_css_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Views_css_app_css__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Views_css_app_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_Views_css_app_css__);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_bus__["a" /* default */]);

var i18n = new __WEBPACK_IMPORTED_MODULE_3_vue_i18n__["a" /* default */]({
  locale: 'zh', // 语言标识 
  messages: {
    'zh': __webpack_require__(12),
    'zh-f': __webpack_require__(13),
    'en': __webpack_require__(14)
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: "#app",
  i18n: i18n,
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_1__app_vue__["a" /* default */]
  }
});

/***/ }),

/***/ 702:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__ = __webpack_require__(284);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_304725b2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__ = __webpack_require__(704);
function injectStyle (ssrContext) {
  __webpack_require__(703)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-304725b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_304725b2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 703:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 704:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isMobile)?_c('div',{staticClass:"topic-pc"},[_c('my-header',{attrs:{"color":"#333"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('h1',{staticClass:"topic-top"},[_vm._v(_vm._s(_vm.$t('topicAll.content1')))]),_vm._v(" "),_c('ul',{staticClass:"topic-ul"},_vm._l((_vm.attentionList.slice(0,6)),function(items,index){return _c('li',{key:index,staticClass:"topic-items"},[_c('img',{attrs:{"src":items.image_url + '_200x200',"alt":""}}),_vm._v(" "),_c('div',{staticClass:"topic-title"},[_c('p',[_c('a',{attrs:{"href":'/topic/' + items.tag}},[_vm._v("#"+_vm._s(items.tag)+"#")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(items.total_feeds)+_vm._s(_vm.$t('topicAll.join')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(items.desc))])])])}),0),_vm._v(" "),_c('p',{staticClass:"topic-top"},[_vm._v(_vm._s(_vm.$t('topicAll.content2')))]),_vm._v(" "),_c('ul',{staticClass:"topic-ul"},_vm._l((_vm.attentionList),function(items,index){return _c('li',{key:index,staticClass:"topic-items"},[_c('img',{attrs:{"src":items.image_url + '_200x200',"alt":""}}),_vm._v(" "),_c('div',{staticClass:"topic-title"},[_c('p',[_c('a',{attrs:{"href":'/topic/' + items.tag}},[_vm._v("#"+_vm._s(items.tag)+"#")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(items.total_feeds)+_vm._s(_vm.$t('topicAll.join')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(items.desc))])])])}),0)]),_vm._v(" "),_c('myFooter')],1):_c('div',{staticClass:"mobile"},[_c('div',{staticClass:"mobile-div"},[_c('h1',{staticClass:"mobile-title"},[_vm._v(_vm._s(_vm.$t('topicAll.content1')))]),_vm._v(" "),_c('ul',{staticClass:"topic-box"},_vm._l((_vm.attentionList.slice(0,5)),function(items,index){return _c('li',{key:index,staticClass:"mobile-topic-items"},[_c('img',{attrs:{"src":items.image_url + '_200x200',"alt":""}}),_vm._v(" "),_c('div',{staticClass:"mobile-topic-txt"},[_c('p',[_c('a',{attrs:{"href":'/topic/'+ items.tag}},[_vm._v("#"+_vm._s(items.tag)+"#")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(items.total_feeds)+_vm._s(_vm.$t('topicAll.join')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(items.desc))])])])}),0),_vm._v(" "),_c('h1',{staticClass:"mobile-title"},[_vm._v(_vm._s(_vm.$t('topicAll.content2')))]),_vm._v(" "),_c('ul',{staticClass:"topic-box"},_vm._l((_vm.attentionList),function(items,index){return _c('li',{key:index,staticClass:"mobile-topic-items"},[_c('img',{attrs:{"src":items.image_url + '_200x200',"alt":""}}),_vm._v(" "),_c('div',{staticClass:"mobile-topic-txt"},[_c('p',[_c('a',{attrs:{"href":'/topic/'+ items.tag}},[_vm._v("#"+_vm._s(items.tag)+"#")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(items.total_feeds)+_vm._s(_vm.$t('topicAll.join')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(items.desc))])])])}),0)]),_vm._v(" "),_c('mobilefoot'),_vm._v(" "),_c('my-menu',{attrs:{"color":"#000"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},[701]);


// WEBPACK FOOTER //
// js/topic-all.94241fd3ba48cdca89bd.js